import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import {
  DirectoryItemAlignment,
  DirectoryItemArrowColor,
} from './directory-item.types';

@Component({
  selector: 'fl-directory-item',
  template: `
    <div
      class="DirectoryItemIcon"
      [attr.data-arrow-color]="arrowColor"
    ></div>
    <div>
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./directory-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DirectoryItemComponent {
  @Input() arrowColor: DirectoryItemArrowColor =
    DirectoryItemArrowColor.DEFAULT;

  @HostBinding('attr.data-alignment')
  @Input()
  alignment: DirectoryItemAlignment = DirectoryItemAlignment.CENTER;
}
